import { AblyProvider as DefaultAblyProvider } from 'ably/react';

import { Loader } from '@repo/ui';

import { AblyWrapper } from './ably-wrapper';
import { useAblyClient } from './use-ably-client';

interface AblyProviderProps {
  children: React.ReactNode;
}

/**
 * AblyProvider component that initializes the Ably client and provides the Ably context to its children.
 * @component
 * @param {AblyProviderProps} props - The properties for the component.
 * @param {React.ReactNode} props.children - The child components to be wrapped by the Ably context.
 * @returns {JSX.Element} The AblyProvider component.
 */
export const AblyProvider: React.FC<AblyProviderProps> = ({
  children,
}: AblyProviderProps) => {
  const ablyClient = useAblyClient();

  if (!ablyClient) {
    return (
      <div className='flex h-screen w-screen items-center justify-center'>
        <Loader
          theme='secondary'
          size='xlarge'
        />
      </div>
    );
  }
  return (
    <DefaultAblyProvider client={ablyClient}>
      <AblyWrapper>{children}</AblyWrapper>
    </DefaultAblyProvider>
  );
};
